import '@stream-io/stream-chat-css/dist/css/index.css';
import Auth0Provider from 'auth0/Auth0Provider';
import LocaleSync from 'components/LocaleSync';
import { CurrentUserContextProvider } from 'components/contexts/CurrentUserContext';
import ApolloProvider from 'graphql/client/ApolloProvider';
import { ConfirmProvider } from 'material-ui-confirm';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Router from 'routes';
import 'utils/sentry';
import CustomErrorBoundary from 'utils/sentry/CustomErrorBoundary';

import { StyledEngineProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


import { configureYup } from '@libs/helpers/yup';
import { SnackbarProvider } from '@libs/ui/components/snackbar/SnackbarProvider';
import defaultTheme from '@libs/ui/themes/v5-theme';

import './i18n';

configureYup();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={defaultTheme}>
      <LegacyThemeProvider theme={defaultTheme}>
        <Auth0Provider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider>
              <CurrentUserContextProvider>
                <ApolloProvider>
                  <LocaleSync>
                    <ConfirmProvider
                      defaultOptions={{
                        confirmationButtonProps: {
                          variant: 'contained',
                          color: 'primary',
                        },
                      }}
                    >
                      <CustomErrorBoundary>
                        <CssBaseline />
                        <Suspense fallback={null}>
                          <Router />
                        </Suspense>
                      </CustomErrorBoundary>
                    </ConfirmProvider>
                  </LocaleSync>
                </ApolloProvider>
              </CurrentUserContextProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        </Auth0Provider>
      </LegacyThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>,
);
